export default {
  appointmentSchedule: 'ตารางการนัดหมายผู้ใช้บริการ',
  patientAppointmentSchedule: 'ตารางนัดหมายคนไข้',
  inspectionSchedule: 'ตารางลงตรวจ',
  doctorAppointmentSchedule: 'ตารางนัดแพทย์',
  selectAppointmentType: 'เลือกประเภทนัดหมาย',
  selectAppointmentStatus: 'เลือกสถานะนัดหมาย',
  selectEmployees: 'เลือกพนักงาน',
  nextAppointment: 'นัดหมายครั้งถัดไป',
  title: {
    createAppointment: 'สร้างนัดหมาย',
    createdBy: 'ผู้ทำนัด',
    createAppointmentTable: 'สร้างตารางการนัดหมาย',
    addInspectionDay: 'เพิ่มวันลงตรวจ',
    ExDetail: 'รายละเอียดวันลงตรวจ'
  },
  headers: {
    date: 'วัน-เวลาที่แก้ไข',
    editBy: 'แก้ไขโดย',
    edit: 'แก้ไข',
    oldData: 'ข้อมูลเก่า',
    newData: 'ข้อมูลใหม่'
  },
  label: {
    oclock: 'น.',
    time: 'เวลานัดหมาย',
    duration: 'ระยะเวลา',
    apmDate: 'จากวันที่',
    branch: 'สาขา',
    person: 'บุคคลที่นัดมาย',
    timeEx: 'เวลาลงตรวจ',
    appList: 'รายการนัดหมาย',
    printDate: 'พิมพ์เมื่อวันที่'
  },
  typeAppointment: {
    buyProduct: 'ซื้อสินค้า',
    serviceTreatment: 'รับการรักษา/บริการ',
    online: 'ออนไลน์',
    counseling: 'รับการปรึกษา'
  },
  alert: {
    successCreateAppointment: 'สร้างตารางนัดหมายคนไข้สำเร็จ !',
    addNextAppointmentToMedicalCertificate: 'เพิ่มนัดหมายครั้งถัดไปในใบรับรองแพทย์ /ใบรับรองแพทย์ (อย่างย่อ) /ใบรับรองการรักษา',
    confirmCancelTitle: 'ยืนยันการยกเลิกนัดลงตรวจ',
    confirmCancelDetail1: 'คุณกำลังยกเลิกนัดลงตรวจ',
    confirmCancelDetail2: 'ต้องการดำเนินการต่อหรือไม่',
    createExSucc: 'สร้างตารางลงตรวจสำเร็จ !',
    todayHaveApp: 'วันนี้มีการนัดหมายแล้ว โปรดตรวจสอบตารางนัดหมาย'
  },
  toolTip: {
    cancel: 'ยกเลิกนัด',
    cancelEx: 'ยกเลิกวันลงตรวจ',
    editEx: 'แก้ไขวันลงตรวจ'
  },
  placeholder: {
    plzSelectTime: 'โปรดเลือกระยะเวลาบริการ',
    searchHnDateTreatment: 'ค้นหา HN , วันที่รักษา',
    selectRoom: 'เลือกห้อง'
  },
  modal: {
    delete: {
      titel: 'ยืนยันการยกเลิกนัด',
      success: 'ยกเลิกนัดลงตรวจสำเร็จ !'
    },
    edit: {
      title: 'แก้ไขนัดหมาย',
      success: 'แก้ไขนัดหมายสำเร็จ !',
      cannotMove: 'ไม่สามารถย้ายวันลงตรวจได้! เนื่องจากมีคนไข้ที่นัดหมายไว้แล้ว'
    }
  },
  error: 'เกิดข้อผิดพลาดขณะบันทึกข้อมูล'
}
